import { lazy } from '@loadable/component';
import { ErrorBoundary } from '@sentry/react';
import { Routes, Route } from 'react-router-dom';
import { useRouterRoutes } from '../components/contexts/RouterContextManager';
import { useRuntimeConfig } from '../runtimeConfig';

const AdminRouter = lazy(() => import(/* webpackChunkName: "adminApplication" */ './AdminRouter'));
const PortalRouter = lazy(() => import(/* webpackChunkName: "publicApplication" */ './PortalRouter'));
const LoginRouter = lazy(() => import(/* webpackChunkName: "loginApplication" */ './LoginRouter'));
const ExternalLinkPage = lazy(() => import(/* webpackChunkName: "externalLinkPage" */ '../pages/ExternalLinkPage'));

const MainRouter = () => {
    const { router } = useRuntimeConfig();
    const routes = useRouterRoutes();
    const hasRoutesWithAuthentication = routes.some(route => route.hasAuthentication);
    const hasLoginRouter = hasRoutesWithAuthentication || router.withAdmin;

    return (
        <ErrorBoundary>
            <Routes>
                {hasLoginRouter ? <Route element={<LoginRouter />} path="auth/*" /> : null}
                {router.withAdmin ? <Route element={<AdminRouter />} path="admin/*" /> : null}
                <Route element={<ExternalLinkPage />} path="l/:id" />
                <Route element={<PortalRouter />} path="*" />
            </Routes>
        </ErrorBoundary>
    );
};

export default MainRouter;
